const BlankLoader = () => {
  return <div className="h-screen w-full" />;
};

export default BlankLoader;
